import { createElementBlock as o, openBlock as l, createElementVNode as t } from "vue";
const n = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-social_facebook"
};
function i(c, e) {
  return l(), o("svg", n, e[0] || (e[0] = [
    t("rect", {
      y: "1.52588e-05",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#41648C"
    }, null, -1),
    t("path", {
      d: "M16.4884 16.0262V21.5H14.1456V16.0262H12.1865V13.893H14.1456V12.3198C14.1456 10.4941 15.3314 9.50002 17.0634 9.50002C17.893 9.50002 18.6062 9.55809 18.814 9.58408V11.4921L17.6125 11.4926C16.6707 11.4926 16.4884 11.9135 16.4884 12.5311V13.893H18.7348L18.4424 16.0262H16.4884Z",
      fill: "white"
    }, null, -1)
  ]));
}
const a = { render: i };
export {
  a as default,
  i as render
};
